import { AxiosError, type InternalAxiosRequestConfig } from 'axios';

import { removeCookie } from '@/shared/helpers/remove-cookie';
import { useAppStateRaw } from '@/shared/store/app-store/app-store';

import { api } from '../api';
import { getToken } from '../auth';

interface InternalAxiosRequestConfigWithRetry extends InternalAxiosRequestConfig {
  _retry: boolean;
}

export const refreshToken = async (error: AxiosError) => {
  const originalRequest = error.config as InternalAxiosRequestConfigWithRetry;

  // To avoid of removing token after market errors
  const isBlockedTillError = !!(error.response?.data as any)?.error?.message?.includes(
    'Blocked till'
  );

  if (
    error instanceof AxiosError &&
    originalRequest &&
    !originalRequest?._retry &&
    (error.response?.status === 403 || error.response?.status === 401) &&
    !isBlockedTillError
  ) {
    originalRequest._retry = true; // avoid infinity loop
    try {
      removeCookie('token');

      const token = await getToken();

      api.defaults.headers.common['Authorization'] = `Bearer ${token}`;
      useAppStateRaw.getState().actions.hydrate({ token });

      return api(originalRequest);
    } catch (refreshError) {
      removeCookie('token');

      window.location.reload();

      return Promise.reject(refreshError);
    }
  }
  return Promise.reject(error);
};
